import {TKraken} from './types';
import loopMap from 'mn-utils/loopMap';
import faker from '@faker-js/faker';

export const getKrakenPayoutList = (limit: number = 5): TKraken[] => {
  return loopMap(limit, getKrakenPayout) as TKraken[];
};

export const getKrakenPayout = (): TKraken => {
  const statuses = ['Initial', 'Pending', 'Settled', 'Success', 'Failure'];
  const amount = +faker.finance.amount(0, 1000, 2);

  return {
    ref_id: faker.datatype.uuid(),
    key: faker.word.adjective(),
    method: faker.word.adjective(),
    asset: faker.finance.currencyCode(),
    info: faker.lorem.lines(1),
    amount,
    fee: +faker.finance.amount(0, amount, 2),
    time: faker.date.recent().toISOString(),
    status: (faker.helpers as any).arrayElement(statuses),
    status_prop: faker.lorem.lines(),
  } as TKraken;
};
